module.exports = __webpack_public_path__ + "img/service-flow-customer.716ad15a.png";